const BreadcrumbTitle = ({ breadcrumbs, titulo }: { breadcrumbs: string; titulo: string }) => {
    const formattedBreadcrumbs = breadcrumbs && breadcrumbs?.includes('>')
        ? breadcrumbs.replaceAll('>', '/')
        : breadcrumbs;

    return (
        <p className="text-[#555C62] text-llarge md:text-tmedium md:truncate">
            {formattedBreadcrumbs} /
            <span className="text-llarge md:text-tmedium text-primary-40"> {titulo}</span>
        </p>
    );
};

export default BreadcrumbTitle